import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

function MiniHeading({ id, Icon, children }) {
  return (
    <StyledMiniHeading>
      <div className="w-100 d-flex justify-content-between align-items-center mb-3">
        <h3 className=" font-weight-bold m-0">
          {Icon && <Icon className="me-2" />}
          <FormattedMessage id={id} />
          {children}
        </h3>
      </div>
    </StyledMiniHeading>
  );
}

export default MiniHeading;

const StyledMiniHeading = styled.div`
  width: 100%;
  font-weight: 500;
  color: #2572bc;
  h3 {
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
  }
`;
